/* eslint-disable unicorn/filename-case */
import { EventAttendeeTypeEnum } from '@app/core/enums/event-attendee-type.enum';
import { IBtrStaticPageApiModel } from '@app/core/models/api/btr-static-page.api.model';
import { ILocationApiV5Model } from '@app/core/models/api/location.api.model';
import { IPlaceApiV5Model } from './place.api.model';
import { ITicketApiModel } from './ticket.api.model';

export interface IBtrEventApiModel {
  id: string;
  slug: string;
  title: string;
  summary: string;
  description: string;
  is_published: boolean;
  start: string; // 2020-12-29T08:00:00Z
  end: string; // 2020-12-29T08:00:00Z
  image: string;
  beacons: Array<IPlaceApiV5Model> | null;
  is_deleted: boolean;
  is_expired: boolean;
  tickets: Array<ITicketApiModel> | null;
  timezone?: string;
  contact_phone: string | null;
  contact_email: string | null;
  footnotes: string | null;
  attendee_info: Array<INewAttendeeInformationApi>;
  attendee_info_fields?: Array<EventAttendeeTypeEnum>;
  attendee_info_fields_required?: Array<EventAttendeeTypeEnum>;
  no_start_time?: boolean;
  no_end_time?: boolean;
  purchase_confirmation_message?: string;
  purchase_email_message?: string;
  purchase_support_email?: string;
  online_event_link?: string;
  online_event_details?: string;
  representation?: IEventRepresentation;
  show_alone: boolean;
  show_in_white_label: boolean;
  is_attendee_info_for_each_ticket: boolean;
  locations: Array<ILocationApiV5Model>;

  formula?: {
    coefs: Array<{
      platform_fixed: number;
      platform_persentage: number;
      stripe_fixed: number;
      stripe_persentage: number;
      threshold: number;
    }>;
    is_default: boolean;
    is_progressive: boolean;
    name: string;
  };

  description_page?: IBtrStaticPageApiModel;
  passport_beacon_groups?: Array<IPassportBeaconGroupApi>;
  verification_tiers?: Array<IVerificationTierApi>;
}

export interface IPassportBeaconGroupApi {
  id: number;
  title: string;
  description?: string;
  threshold: number;
  beacon_ids: Array<number>;
}

export interface IVerificationTierApi {
  id: number;
  title: string;
  description?: string;
  how_to_claim?: string;
  threshold: number;
  threshold_groups?: number;
  is_verify_ticket?: boolean;
}

export interface IBtrEventListGetRequest {
  user?: string;
  cluster?: number;
  limit?: number;
  offset?: number;
  search?: string;
  sort?: 'added' | 'start' | 'alphabetically';
  sort_order?: 'ASC' | 'DESC';
  filters?: string | 'free' | 'paid' | 'no-ticket' | 'actual' | 'expired';
  output_fields?: 'beacons' | 'tickets' | 'tickets.statuses' | string;
}

export interface IEventRepresentation {
  background_color?: string;
  description?: string;
  image_url?: string;
  logo_url?: string;
  primary_color?: string;
  secondary_color?: string;
  title?: string;
}

export interface INewAttendeeInformationApi {
  slug?: string;
  slugs?: Array<string>;
  name?: string;
  title: string;
  type: EAttendeeInformation;
  choices: { [key: string]: string };
  descriptions?: string;
  is_visible: boolean;
  is_required: boolean;
  is_visible_in_scanner: boolean;
  is_required_in_scanner: boolean;
}

export enum EAttendeeInformation {
  TEXT = 'text',
  SINGLE_CHOICE = 'choice_single',
  SINGLE_CHOICE_WITH_OTHER = 'choice_single_with_other',
  MULTIPLE_CHOICE = 'choice_multiple',
  MULTIPLE_CHOICE_WITH_OTHER = 'choice_multiple_with_other',
  DATE = 'date',
  PHONE = 'phone',
  EMAIL = 'email',
  NUMBER = 'number',
  FLAG = 'flag',
  RATE = 'rate5',
  IMAGE = 'image',
}

export enum EDefaultAttendeeName {
  FIRST_NAME = 'first_name',
  LAST_NAME = 'last_name',
  EMAIL = 'email',
  ZIP = 'zip',
}

export enum EDefaultAttendeeSlug {
  FIRST_NAME = 'info_first_name',
  LAST_NAME = 'info_last_name',
  EMAIL = 'info_email',
  ZIP = 'info_zip',
}
